import { ProjectHeaderResponse } from '@/types/service-response'

export class ProjectDetailHeader {
  public constructor (
    readonly Projekt: string,
    readonly ProjektDatum: string,
    readonly ReferenzTermin: string,
    readonly Titel: string,
    readonly Nummer: string,
    readonly IhreReferenz: string,
    readonly Adresse: string,
    readonly AdressNummer: string,
    readonly AdressLinie: string,
    readonly AdressFeld: string,
    readonly ProfitCenter: string,
    readonly ProfitCenterCode: string,
    readonly Sprache: string,
    readonly ProfitCenterBezeichnung: string,
    readonly ProzessArt: string,
    readonly ProzessArtCode: string,
    readonly ProzessArtBezeichnung: string,
    readonly EingangViaBzg: string,
    readonly Sachbearbeiter: string,
    readonly SachbearbeiterNameK: string,
    readonly UnsereReferenz: string,
    readonly UnsereReferenzNameK: string,
    readonly UnsereReferenzKurzzeichen: string,
    readonly UnsereReferenzName: string,
    readonly UnsereReferenzVorname: string,
    readonly UnsereReferenzVollerName: string,
    readonly Lieferkondition: string,
    readonly LieferkonditionCode: string,
    readonly LieferkonditionBezeichnung: string,
    readonly Zahlungskondition: string,
    readonly ZahlungskonditionCode: string,
    readonly ZahlungskonditionBezeichnung: string,
    readonly Versandart: string,
    readonly VersandartCode: string,
    readonly VersandartBezeichnung: string,
    readonly Rabattsteuer: string,
    readonly RabattsteuerCode: string,
    readonly RabattsteuerBezeichnung: string,
    readonly Zuschlagsteuer: string,
    readonly ZuschlagsteuerCode: string,
    readonly ZuschlagsteuerBezeichnung: string,
    readonly Versandsteuer: string,
    readonly VersandsteuerCode: string,
    readonly VersandsteuerBezeichnung: string,
    readonly Express: string,
    readonly Einschreiben: string,
    readonly Nachnahme: string,
    readonly RabattProzent: string,
    readonly Rabatt: string,
    readonly Versandspesen: string,
    readonly Zuschlag: string,
    readonly RabattKonto: string,
    readonly VersandKonto: string,
    readonly ZuschlagKonto: string,
    readonly Gesperrt: string,
    readonly GesperrtVon: string,
    readonly GesperrtVonNameK: string,
    readonly Leitwaehrung: string,
    readonly WaehrungISOCode: string,
    readonly WaehrungBezeichnung: string,
    readonly MDT: string,
    readonly Auslieferort: string,
    readonly AuslieferortCode: string,
    readonly AuslieferortBzg: string
  ) {}

  static createFromResponse (responseData: ProjectHeaderResponse): ProjectDetailHeader {
    return new ProjectDetailHeader(
      responseData.Projekt ? responseData.Projekt : '',
      responseData.ProjektDatum ? responseData.ProjektDatum : '',
      responseData.ReferenzTermin ? responseData.ReferenzTermin : '',
      responseData.Titel ? responseData.Titel : '',
      responseData.Nummer ? responseData.Nummer : '',
      responseData.IhreReferenz ? responseData.IhreReferenz : '',
      responseData.Adresse ? responseData.Adresse : '',
      responseData.AdressNummer ? responseData.AdressNummer : '',
      responseData.AdressLinie ? responseData.AdressLinie : '',
      responseData.AdressFeld ? responseData.AdressFeld : '',
      responseData.ProfitCenter ? responseData.ProfitCenter : '',
      responseData.ProfitCenterCode ? responseData.ProfitCenterCode : '',
      responseData.Sprache ? responseData.Sprache : '',
      responseData.ProfitCenterBezeichnung ? responseData.ProfitCenterBezeichnung : '',
      responseData.ProzessArt ? responseData.ProzessArt : '',
      responseData.ProzessArtCode ? responseData.ProzessArtCode : '',
      responseData.ProzessArtBezeichnung ? responseData.ProzessArtBezeichnung : '',
      responseData.EingangViaBzg ? responseData.EingangViaBzg : '',
      responseData.Sachbearbeiter ? responseData.Sachbearbeiter : '',
      responseData.SachbearbeiterNameK ? responseData.SachbearbeiterNameK : '',
      responseData.UnsereReferenz ? responseData.UnsereReferenz : '',
      responseData.UnsereReferenzNameK ? responseData.UnsereReferenzNameK : '',
      responseData.UnsereReferenzKurzzeichen ? responseData.UnsereReferenzKurzzeichen : '',
      responseData.UnsereReferenzName ? responseData.UnsereReferenzName : '',
      responseData.UnsereReferenzVorname ? responseData.UnsereReferenzVorname : '',
      responseData.UnsereReferenzVollerName ? responseData.UnsereReferenzVollerName : '',
      responseData.Lieferkondition ? responseData.Lieferkondition : '',
      responseData.LieferkonditionCode ? responseData.LieferkonditionCode : '',
      responseData.LieferkonditionBezeichnung ? responseData.LieferkonditionBezeichnung : '',
      responseData.Zahlungskondition ? responseData.Zahlungskondition : '',
      responseData.ZahlungskonditionCode ? responseData.ZahlungskonditionCode : '',
      responseData.ZahlungskonditionBezeichnung ? responseData.ZahlungskonditionBezeichnung : '',
      responseData.Versandart ? responseData.Versandart : '',
      responseData.VersandartCode ? responseData.VersandartCode : '',
      responseData.VersandartBezeichnung ? responseData.VersandartBezeichnung : '',
      responseData.Rabattsteuer ? responseData.Rabattsteuer : '',
      responseData.RabattsteuerCode ? responseData.RabattsteuerCode : '',
      responseData.RabattsteuerBezeichnung ? responseData.RabattsteuerBezeichnung : '',
      responseData.Zuschlagsteuer ? responseData.Zuschlagsteuer : '',
      responseData.ZuschlagsteuerCode ? responseData.ZuschlagsteuerCode : '',
      responseData.ZuschlagsteuerBezeichnung ? responseData.ZuschlagsteuerBezeichnung : '',
      responseData.Versandsteuer ? responseData.Versandsteuer : '',
      responseData.VersandsteuerCode ? responseData.VersandsteuerCode : '',
      responseData.VersandsteuerBezeichnung ? responseData.VersandsteuerBezeichnung : '',
      responseData.Express ? responseData.Express : '',
      responseData.Einschreiben ? responseData.Einschreiben : '',
      responseData.Nachnahme ? responseData.Nachnahme : '',
      responseData.RabattProzent ? responseData.RabattProzent : '',
      responseData.Rabatt ? responseData.Rabatt : '',
      responseData.Versandspesen ? responseData.Versandspesen : '',
      responseData.Zuschlag ? responseData.Zuschlag : '',
      responseData.RabattKonto ? responseData.RabattKonto : '',
      responseData.VersandKonto ? responseData.VersandKonto : '',
      responseData.ZuschlagKonto ? responseData.ZuschlagKonto : '',
      responseData.Gesperrt ? responseData.Gesperrt : '',
      responseData.GesperrtVon ? responseData.GesperrtVon : '',
      responseData.GesperrtVonNameK ? responseData.GesperrtVonNameK : '',
      responseData.Leitwaehrung ? responseData.Leitwaehrung : '',
      responseData.WaehrungISOCode ? responseData.WaehrungISOCode : '',
      responseData.WaehrungBezeichnung ? responseData.WaehrungBezeichnung : '',
      responseData.MDT ? responseData.MDT : '',
      responseData.Auslieferort ? responseData.Auslieferort : '',
      responseData.AuslieferortCode ? responseData.AuslieferortCode : '',
      responseData.AuslieferortBzg ? responseData.AuslieferortBzg : '',)
  }
}
